// extracted by mini-css-extract-plugin
module.exports = {"container":"part-reviews-and-contact-form_container__YQFCr","wrap":"part-reviews-and-contact-form_wrap__5gmh0"};